import React, { Component } from "react";
import { Link } from "react-router-dom";
import AlertNews from "../main/alert-news/alert-news";
import Swal from "sweetalert2";
import AppContext from "../appContext";

class Module extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    Module.contextType = AppContext;
    this.clickPromo = this.clickPromo.bind(this);
  }

  clickPromo(url) {
    window.open(url, "_blank");
  }

  render() {
    return (
      <li 
        className="module" 
        key={this.props.index} 
        onClick={(e) => {
          if (e.target.tagName !== 'A' && e.target.tagName !== 'BUTTON') {
            if (this.props.nome !== "Essilor Promo" && Boolean(this.props.url)) {
              const isExternalLink = new URL(this.props.url, window.location.href).origin !== window.location.origin;
              if (isExternalLink) {
                window.open(this.props.url, '_blank');
              } else {
                window.location.href = this.props.url;
              }
            }else if(this.props.nome == "Essilor Promo"){
              e.stopPropagation();
              this.clickPromo(this.props.url, this.props.target);
            }
          }
        }}
        style={{ cursor: 'pointer' }}  
      >
        <div className="module_logo">
          <AlertNews data={this.props.dataLimiteNovidade} mensagem={this.props.mensagemNovidade} />
          <img src={this.props.logo} alt="" className="module_logo-img" />
        </div>
    
        {this.props.nome === "Essilor Promo" ? (
          <>
            <button 
              className="module_button" 
              onClick={(e) => {
                e.stopPropagation();
                this.clickPromo(this.props.url, this.props.target);
              }}
            >
              <span className="module_button-text">{this.props.message}</span>
            </button>
          </>
        ) : (
          <>
            <a 
              href={this.props.url} 
              target={this.props.target} 
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <button className="module_button">
                <span className="module_button-text">{this.props.message}</span>
              </button>
            </a>
          </>
        )}
      </li>
    );
    
    
    
  }
}

export default Module;
